import { render, staticRenderFns } from "./upload_img.vue?vue&type=template&id=5b321c05&scoped=true"
import script from "./upload_img.vue?vue&type=script&lang=js"
export * from "./upload_img.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b321c05",
  null
  
)

export default component.exports